import { render, staticRenderFns } from "./LongtextInput.vue?vue&type=template&id=0d20b709&"
import script from "./LongtextInput.vue?vue&type=script&lang=js&"
export * from "./LongtextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports